import { addDays, format, parse } from 'date-fns';

import { AppointmentType, AppointmentTypeOption } from '../../booking.types';
import { HOLD_API_DATE_FORMAT } from './constants';

enum PatientType {
  New = 'New',
  Current = 'Current',
  NewCurrent = 'New/Current',
}

export const getAvailabeAppointmentTypes = (
  availableAppointmentTypes: AppointmentType[],
  isNewPatient: boolean
): AppointmentTypeOption[] => {
  const selectOption = {
    label: 'Select',
    value: 'select',
    selected: true,
  };

  if (!availableAppointmentTypes) return [];

  const filterByNewPatient = (appointmentType: AppointmentType) => {
    if (isNewPatient) {
      return (
        appointmentType.patientType.includes(PatientType.New) ||
        appointmentType.patientType.includes(PatientType.NewCurrent)
      );
    }
    return (
      appointmentType.patientType.includes(PatientType.Current) ||
      appointmentType.patientType.includes(PatientType.NewCurrent)
    );
  };

  const filterByTextingWorkflow = (appointmentType: AppointmentType) => {
    if (typeof window === 'undefined') return true;

    // if location path includes 'texting', allow all appointment types
    if (document.location.pathname.includes('texting')) {
      return true;
    }

    // filter out ER Private unless urlPath contains 'texting'
    if (appointmentType.mhdAppointmentTypeName.includes('ER Private')) {
      return false;
    }

    // else filter nothing
    return true;
  };

  const mappedOptions = availableAppointmentTypes
    .filter(filterByNewPatient)
    .filter(filterByTextingWorkflow)
    .map((x) => ({
      label: x.friendlyName2,
      value: x.code,
      selected: false,
    }));

  return [selectOption, ...mappedOptions];
};

export const getTodayDateFormatted = (): string => {
  const today = new Date();
  return format(today, HOLD_API_DATE_FORMAT);
};

export const parseDate = (dateString: string): Date | string => {
  if (!dateString) return '';
  return parse(dateString, HOLD_API_DATE_FORMAT, new Date());
};

export const getNextFormatted = (date: string): string => {
  const parsedDate = parse(date, HOLD_API_DATE_FORMAT, new Date());
  const nextDay = addDays(parsedDate, 1);
  return format(nextDay, HOLD_API_DATE_FORMAT);
};
